import { table } from "../models.model";

export const FEC_CHOROTEGA_TOTAL: table = {
  columnas: [
    'Fondo de Estabilización Cooperativa (FEC)',
    'Total',
  ],
  filas:[
    {
      type: 'operacion',
      id: 'P202101',
      bandas: [1],
      descripcion: 'Ahorro retirable',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202201'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'P202103',
      bandas: [1],
      descripcion: 'Depósitos a plazo',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202103'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202203'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'V07',
      bandas: [1],
      descripcion: '(-) Depósitos FEC de FEC',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaATV', valor: 'V07'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaATV', valor: 'V08'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'V09',
      bandas: [1],
      descripcion: '(-) Depósitos de ahorro recibidos de cooperativas (para constitución de fondos FEC)',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaATV', valor: 'V09'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaATV', valor: 'V10'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope1',
      bandas: [1],
      descripcion: 'Depósitos de ahorro netos para constituir FEC',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'cuenta', valor: 'P202103'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'V07'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'V09'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'fijo',
      bandas: [1],
      descripcion: '% FEC (Banco Central como Encaje Legal)',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'numero', valor: 0}
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope2',
      bandas: [1],
      descripcion: 'Inversiones Requeridas',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202103'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consultaATV', valor: 'V07'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consultaATV', valor: 'V09'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 0.09},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P202201'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202203'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consultaATV', valor: 'V08'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consultaATV', valor: 'V10'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 0.24},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'A102102',
      bandas: [1],
      descripcion: 'Inversiones en fondos especiales',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A102202'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'A1011030299',
      bandas: [1],
      descripcion: 'Transitoria para Efectos del Fondo de Estabilización Cooperativa (FEC)',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A1011030299'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A1012030299'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'V05',
      bandas: [1],
      descripcion: 'Monto de créditos otorgados con el 50% L/P FEC',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaATV', valor: 'V05'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaATV', valor: 'V06'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope3',
      bandas: [1],
      descripcion: 'Inversiones Constituidas',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'A102102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'cuenta', valor: 'A1011030299'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'cuenta', valor: 'V05'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope4',
      bandas: [1],
      descripcion: 'Requeridas - Constituidas',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'ope2'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'ope3'},
          ]
        }
      ],
      calculo: [1],
    },
  ]
}
export const FEC_CHOROTEGA_MN: table = {
  columnas: [
    'Fondo de Estabilización Cooperativa (FEC)',
    'Moneda Nacional',
  ],
  filas:[
    {
      type: 'operacion',
      id: 'P202101',
      bandas: [1],
      descripcion: 'Ahorro retirable',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202101'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'P202103',
      bandas: [1],
      descripcion: 'Depósitos a plazo',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202103'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'V07',
      bandas: [1],
      descripcion: '(-) Depósitos FEC de FEC',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaATV', valor: 'V07'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'V09',
      bandas: [1],
      descripcion: '(-) Depósitos de ahorro recibidos de cooperativas (para constitución de fondos FEC)',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaATV', valor: 'V09'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope1',
      bandas: [1],
      descripcion: 'Depósitos de ahorro netos para constituir FEC',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'cuenta', valor: 'P202103'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'V07'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'V09'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'fijo',
      bandas: [1],
      descripcion: '% FEC (Banco Central como Encaje Legal)',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'numero', valor: 0.09}
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope2',
      bandas: [1],
      descripcion: 'Inversiones Requeridas',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'ope1'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 0.09},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'A102102',
      bandas: [1],
      descripcion: 'Inversiones en fondos especiales',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102102'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'A1011030299',
      bandas: [1],
      descripcion: 'Transitoria para Efectos del Fondo de Estabilización Cooperativa (FEC)',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A1011030299'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'V05',
      bandas: [1],
      descripcion: 'Monto de créditos otorgados con el 50% L/P FEC',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaATV', valor: 'V05'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope3',
      bandas: [1],
      descripcion: 'Inversiones Constituidas',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'A102102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'cuenta', valor: 'A1011030299'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'cuenta', valor: 'V05'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope4',
      bandas: [1],
      descripcion: 'Requeridas - Constituidas',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'ope2'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'ope3'},
          ]
        }
      ],
      calculo: [1],
    },
  ]
}
export const FEC_CHOROTEGA_ME: table = {
  columnas: [
    'Fondo de Estabilización Cooperativa (FEC)',
    'Moneda extranjera',
  ],
  filas:[
    {
      type: 'operacion',
      id: 'P202101',
      bandas: [1],
      descripcion: 'Ahorro retirable',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202201'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'P202103',
      bandas: [1],
      descripcion: 'Depósitos a plazo',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202203'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'V07',
      bandas: [1],
      descripcion: '(-) Depósitos FEC de FEC',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaATV', valor: 'V08'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'V09',
      bandas: [1],
      descripcion: '(-) Depósitos de ahorro recibidos de cooperativas (para constitución de fondos FEC)',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaATV', valor: 'V10'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope1',
      bandas: [1],
      descripcion: 'Depósitos de ahorro netos para constituir FEC',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'cuenta', valor: 'P202103'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'V07'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'V09'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'fijo',
      bandas: [1],
      descripcion: '% FEC (Banco Central como Encaje Legal)',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'numero', valor: 0.24}
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope2',
      bandas: [1],
      descripcion: 'Inversiones Requeridas',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'ope1'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 0.24},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'A102102',
      bandas: [1],
      descripcion: 'Inversiones en fondos especiales',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102202'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'A1011030299',
      bandas: [1],
      descripcion: 'Transitoria para Efectos del Fondo de Estabilización Cooperativa (FEC)',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A1012030299'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'V05',
      bandas: [1],
      descripcion: 'Monto de créditos otorgados con el 50% L/P FEC',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaATV', valor: 'V06'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope3',
      bandas: [1],
      descripcion: 'Inversiones Constituidas',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'A102102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'cuenta', valor: 'A1011030299'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'cuenta', valor: 'V05'},
          ]
        }
      ],
      calculo: [1],
    },
    {
      type: 'operacion',
      id: 'ope4',
      bandas: [1],
      descripcion: 'Requeridas - Constituidas',
      visible: true,
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'ope2'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'ope3'},
          ]
        }
      ],
      calculo: [1],
    },
  ]
}